<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let circleFill = "#6d6f76";
	export let arrowFill = "#333338";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 20 18.895">
	<g transform="translate(-49.001 -132.074)">
		<ellipse
			cx="9.445"
			cy="9.448"
			rx="9.445"
			ry="9.448"
			transform="translate(50.112 132.074)"
			fill={circleFill} />
		<g>
			<g>
				<path
					d="M71.568 90.2a.306.306 0 0 1-.22-.519l6.141-6.349-6.141-6.349a.306.306 0 0 1 .44-.426l6.347 6.562a.306.306 0 0 1 0 .426l-6.347 6.565a.307.307 0 0 1-.22.09z"
					transform="translate(-13.835 58.4)"
					fill={arrowFill} />
			</g>
			<g>
				<path
					d="M58.826 98.506H44.053a.306.306 0 1 1 0-.612h14.773a.306.306 0 1 1 0 .612z"
					transform="translate(5.254 43.535)"
					fill={arrowFill} />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
</style>
